module.exports = __webpack_public_path__ + "static/media/truckmap.6eb17e83.png";